/* ============================================================
   von Kirch — Theme JS  v2.0
   ============================================================ */

(function () {
  'use strict';

  /* ---- Helpers ---- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function imgUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  /* ============================================================
     HEADER — scroll behavior
     ============================================================ */
  var header = document.getElementById('site-header');
  var isHome = document.body.classList.contains('template-index');

  function syncHeader() {
    if (!header) return;
    var solid = !isHome || window.scrollY > 40;
    header.classList.toggle('is-solid', solid);
  }
  if (header) {
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  var overlay = document.getElementById('vk-overlay');
  var drawer  = document.getElementById('vk-cart-drawer');

  window.vkOpenCart = function () {
    if (!drawer) return;
    overlay && overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    vkRefreshCart();
  };

  window.vkCloseCart = function () {
    if (!drawer) return;
    overlay && overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  function vkRefreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(vkRenderCart)
      .catch(function () {});
  }

  function vkRenderCart(cart) {
    /* Update badge */
    var badge = document.getElementById('vk-cart-count');
    if (badge) {
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }

    if (!drawer) return;

    var emptyEl  = document.getElementById('vk-drawer-empty');
    var itemsEl  = document.getElementById('vk-drawer-items');
    var footEl   = document.getElementById('vk-drawer-foot');
    var totalEl  = document.getElementById('vk-drawer-total');

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = '';
      if (itemsEl) itemsEl.innerHTML = '';
      if (footEl)  footEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl)  footEl.style.display = '';
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (!itemsEl) return;
    itemsEl.innerHTML = cart.items.map(function (item) {
      var k = String(item.key).replace(/'/g, "\\'");
      var img = item.image ? '<img src="' + esc(imgUrl(item.image, '200x')) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="vk-cart-item__variant">' + esc(item.variant_title) + '</p>' : '';
      return (
        '<div class="vk-cart-item">' +
          '<a href="' + esc(item.url) + '" class="vk-cart-item__img">' + img + '</a>' +
          '<div class="vk-cart-item__info">' +
            '<div class="vk-cart-item__top">' +
              '<div>' +
                '<a href="' + esc(item.url) + '" class="vk-cart-item__name">' + esc(item.product_title) + '</a>' +
                variant +
              '</div>' +
              '<span class="vk-cart-item__price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            '<div class="vk-cart-item__actions">' +
              '<div class="vk-qty">' +
                '<button type="button" class="vk-qty__btn" onclick="vkUpdateCart(\'' + k + '\',' + Math.max(0, item.quantity - 1) + ')">&#8722;</button>' +
                '<span class="vk-qty__val">' + item.quantity + '</span>' +
                '<button type="button" class="vk-qty__btn" onclick="vkUpdateCart(\'' + k + '\',' + (item.quantity + 1) + ')">+</button>' +
              '</div>' +
              '<button type="button" class="vk-cart-item__remove" onclick="vkUpdateCart(\'' + k + '\',0)">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  window.vkUpdateCart = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        vkRenderCart(cart);
        /* If on cart page and now empty, reload */
        if (cart.item_count === 0 && document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function () {});
  };

  /* ============================================================
     INTERCEPT add-to-cart → AJAX → open drawer
     ============================================================ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var idInput  = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput) return;

    var variantId = parseInt(idInput.value, 10);
    var quantity  = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
        vkOpenCart();
      })
      .catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
      });
  });

  /* ============================================================
     Initial cart badge refresh on page load
     ============================================================ */
  vkRefreshCart();

})();
